module.exports = __webpack_public_path__ + "img/daidakuan.1cf10e1d.png";